var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"battery-use-chart-container",staticClass:"battery-use-chart-container"})}
var staticRenderFns = []

export { render, staticRenderFns }